import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Typography, Card, Spin, Empty, Button } from "antd";
import {
  ArrowLeftOutlined,
  FileTextOutlined,
  SafetyOutlined,
  CustomerServiceOutlined,
  BookOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import Header from "../../components/Header";
import "./style.css";

const { Title, Text } = Typography;

const HelpDetail = () => {
  const { id } = useParams();
  const [tutorial, setTutorial] = useState(null);
  const [loading, setLoading] = useState(true);

  // 分类图标映射
  const categoryIcons = {
    "操作指南": <FileTextOutlined />,
    "功能效果": <SafetyOutlined />,
    "家校沟通": <CustomerServiceOutlined />,
    "模板合集": <BookOutlined />,
    "接龙相关": <CheckCircleOutlined />,
  };

  // 获取教程详情
  const fetchTutorialDetail = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://hui51.cn/api/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          operationName: 'guidesWithCount',
          query: `
            query guidesWithCount($type: String, $cat: String, $_search: String, $limit: String, $skip: String) {
              guidesWithCount(type: $type, cat: $cat, _search: $_search, limit: $limit, skip: $skip, sort: "order") {
                total
                guides {
                  _id
                  title
                  type
                  cat
                  order
                  value
                  createdAt
                  updatedAt
                }
              }
            }
          `,
          variables: {
            type: 'html',
            limit: '1000',
            skip: 0
          }
        })
      });

      const data = await response.json();
      if (data.data && data.data.guidesWithCount) {
        const foundTutorial = data.data.guidesWithCount.guides.find(g => g._id === id);
        setTutorial(foundTutorial);
      }
    } catch (error) {
      console.error('获取教程详情失败:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTutorialDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // 更新页面标题
  useEffect(() => {
    if (tutorial) {
      document.title = `${tutorial.title} - 秒应帮助文档`;
    } else {
      document.title = '教程详情 - 秒应帮助文档';
    }
  }, [tutorial]);

  if (loading) {
    return (
      <div className="help-detail-page">
        <Header activePath="/help" />
        <div className="help-detail-container">
          <div className="container" style={{ textAlign: 'center', padding: '100px 0' }}>
            <Spin size="large" />
          </div>
        </div>
      </div>
    );
  }

  if (!tutorial) {
    return (
      <div className="help-detail-page">
        <Header activePath="/help" />
        <div className="help-detail-container">
          <div className="container" style={{ textAlign: 'center', padding: '100px 0' }}>
            <Empty description="教程不存在" />
            <Link to="/help">
              <Button type="primary" style={{ marginTop: 20, borderRadius: 20 }}>
                返回帮助文档
              </Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="help-detail-page">
      <Header activePath="/help" />

      <div className="help-detail-container">
        <div className="container">
          {/* Breadcrumb */}
          <div className="breadcrumb">
            <Link to="/help">帮助文档</Link>
            <span className="separator">/</span>
            <span className="current">{tutorial.cat}</span>
          </div>

          {/* Back Button */}
          <div className="back-button">
            <Link to="/help">
              <Button icon={<ArrowLeftOutlined />}>
                返回列表
              </Button>
            </Link>
          </div>

          {/* Tutorial Content */}
          <Card className="tutorial-detail-card">
            <div className="tutorial-detail-header">
              <div className="tutorial-category">
                <span className="category-icon">
                  {categoryIcons[tutorial.cat] || <FileTextOutlined />}
                </span>
                <span>{tutorial.cat}</span>
              </div>
              <Title level={1} className="tutorial-title">
                {tutorial.title}
              </Title>
              <div className="tutorial-meta">
                <Text type="secondary">
                  更新时间: {tutorial.updatedAt ? new Date(tutorial.updatedAt).toLocaleDateString('zh-CN') : '-'}
                </Text>
              </div>
            </div>

            <div className="tutorial-detail-content">
              <div
                className="tutorial-html-content"
                dangerouslySetInnerHTML={{ __html: tutorial.value || '' }}
              />
            </div>
          </Card>
        </div>
      </div>

      {/* CTA - 与首页一致 */}
      <section className="cta">
        <div className="container">
          <div className="cta-content">
            <h2>现在就试试秒应</h2>
            <p>扫码立即体验，免费使用，无需注册</p>
            <div className="cta-qr-codes">
              <div className="qr-item">
                <img src="/assets/code1.8137c5d.jpg" alt="微信小程序码" className="qr-img" />
                <span className="qr-label">微信小程序</span>
              </div>
              <div className="qr-item">
                <img src="/assets/code4.6658546.jpg" alt="网页版二维码" className="qr-img" />
                <span className="qr-label">微信公众号</span>
              </div>
              <div className="qr-item">
                <img src="/assets/code3.563ecfb.jpg" alt="客服微信" className="qr-img" />
                <span className="qr-label">客服微信：jizhitech</span>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default HelpDetail;
